import { forEach } from 'lodash-es';
import { createRoot, hydrateRoot } from 'react-dom/client';
import ReactDomServer from 'react-dom/server';
/**
 * Mount the components returned by the renderer function onto each element
 * that has the provided class name, and load the props data from the script
 * element within that element.
 *
 * @param {string} wrapperClassName
 * @param {function} renderer
 * @return {undefined}
 */
export const mountComponentByClassWithData = (wrapperClassName, renderer) => {
    forEach(document.querySelectorAll('.' + wrapperClassName), wrapper => {
        const dataElement = wrapper.querySelector('script');
        if (!dataElement) {
            throw new Error(`Unable to load data for component when mounting "{wrapperClassName}"!`);
        }
        createRoot(wrapper).render(renderer(JSON.parse(dataElement.innerHTML)));
    });
};
/**
 * Hydrate the components returned by the renderer function onto each element
 * that has the provided class name, and load the props data from the script
 * element within that element.
 *
 * @param {string} wrapperClassName
 * @param {function} renderer
 * @return {undefined}
 */
export const hydrateComponentByClassWithData = (wrapperClassName, renderer) => {
    forEach(document.querySelectorAll('.' + wrapperClassName), wrapper => {
        const dataElement = wrapper.querySelector('script');
        if (!dataElement) {
            throw new Error(`Unable to load data for component when mounting "{wrapperClassName}"!`);
        }
        hydrateRoot(wrapper, renderer(JSON.parse(dataElement.innerHTML)));
    });
};
/**
 * Render the component returned by the renderer function and distpach the HTML string
 *
 * @param {string} wrapperClassName
 * @param {function} renderer
 * @return {undefined}
 */
export const serverSideRenderComponent = (renderer) => {
    const html = ReactDomServer.renderToString(renderer(context.props));
    dispatch(html);
};
